// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02d87005","455":"38968969"}[chunkId] + ".chunk.js";
};